import { render, staticRenderFns } from "./messagesTab.vue?vue&type=template&id=1d323112&scoped=true&"
import script from "./messagesTab.vue?vue&type=script&lang=js&"
export * from "./messagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d323112",
  null
  
)

export default component.exports